import { NotificationService } from "./notification.service";
export * from "./notification.types";
export * from "./notification.utils";

const notificationService = new NotificationService();
export default notificationService;
export type INotificationService = typeof notificationService;
